import { useQuery } from '@tanstack/react-query';
import { appApiAiCenter } from 'configs/variables';
import useHttpClient from 'hooks/useHttpClient';
import { suspectKeys } from '../keys';

// GET /api/suspects/
// params: { skip, limit }
export function useGetSuspects({ filter = undefined } = {}) {
  const { get } = useHttpClient();

  const queryRequest = useQuery({
    queryKey: suspectKeys.all(filter).queryKey,
    queryFn: async () =>
      await get({
        url: appApiAiCenter + '/suspects/',
        params: filter,
      }),
    select: (res) => res?.suspects || [],
  });

  return queryRequest;
}
